import { useCallback } from "react"
import { useSearchParams } from "react-router"

const useSearchParamValue = <T extends string>(
  param: string,
): [T | null, (value: T | null) => void] => {
  const [searchParams, setSearchParams] = useSearchParams()

  const setSearchParamValue = useCallback(
    (value: T | null) => {
      const newSearchParams = new URLSearchParams(searchParams)
      if (value === null) {
        newSearchParams.delete(param)
      } else {
        newSearchParams.set(param, value)
      }
      setSearchParams(newSearchParams)
    },
    [param, searchParams, setSearchParams],
  )

  return [searchParams.get(param) as T | null, setSearchParamValue]
}

export default useSearchParamValue
